import { cn } from '@/lib/utils/cn';

/*
  Los colores de los avatares, de la paleta de Prixia (reunión del 14-oct): el
  artefacto pinta cada persona de un color distinto para que la lista se lea de
  un vistazo. El texto va en blanco salvo sobre el dorado, que lo pide oscuro
  (como Comercia en el menú).
*/
const COLORES = [
  'bg-primary text-primary-foreground',
  'bg-prixia-ink text-white',
  'bg-prixia-blue text-white',
  'bg-prixia-gold text-prixia-ink',
  'bg-ok text-white',
  'bg-prixia-sky text-prixia-ink',
] as const;

/** Las iniciales de un nombre: «Roberto Méndez» → «RM»; «malba» → «MA». */
export function inicialesDePersona(nombre: string): string {
  const partes = nombre.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return '?';
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
  return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
}

/** El mismo nombre da siempre el mismo color, en esta pantalla y en la que sigue. */
function colorDe(clave: string): string {
  let h = 0;
  for (let i = 0; i < clave.length; i++) h = (h * 31 + clave.charCodeAt(i)) | 0;
  return COLORES[Math.abs(h) % COLORES.length];
}

/**
 * La persona como un círculo con sus iniciales (rediseño del 18-oct, artefacto
 * «Mi empresa · Usuarios / Equipos»). Es decorativo: el nombre siempre va al
 * lado, así que el lector de pantalla no lo repite.
 */
export function AvatarDePersona({
  nombre,
  clave,
  className,
}: {
  nombre: string;
  /** Lo que fija el color (el id o el correo). Sin clave, el nombre. */
  clave?: string;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'grid h-9 w-9 shrink-0 place-items-center rounded-full text-[12px] font-semibold',
        colorDe(clave ?? nombre),
        className
      )}
    >
      {inicialesDePersona(nombre)}
    </span>
  );
}
